/**
 * Global contact constants for the application
 * Centralized phone numbers and opening hours
 */

// Loan Insurance Contact
export const LOAN_PHONE_NUMBER = '01 82 83 36 33'
export const LOAN_PHONE_LINK = 'tel:0182833633'
export const LOAN_OPENING_HOURS = 'du lundi au vendredi 9h/18h'

// Health Insurance Contact
export const HEALTH_PHONE_NUMBER = '01 88 46 94 67'
export const HEALTH_PHONE_LINK = 'tel:0188469467'
export const HEALTH_OPENING_HOURS = 'du lundi au vendredi 9h/18h'
